import React from 'react';
import copyProps from '../utils/copy-props';
import VstComponent from './VstComponent';
import VstTableHeader from './VstTableHeader';
import VstTableBody from './VstTableBody';
import VstTableRow from './VstTableRow';
import VstTableCell from './VstTableCell';
import { css } from 'glamor';

/*
  Data passed in should include props for 'headers' and 'items'
  The keys for 'items' should match the keys for headers

  By default items will be sorted on their string value passed in
  For something different (such as dates or prices before appending currencies),
  add an additional key prepended with '_sort_'.
  For example, for {price="$1.00"} you'd add {_sort_price:1.00}

*/
class VstTable extends VstComponent {

  // TODO: Handle when original props change
  constructor() {
    super();
    this._toggleSortOrder = this._toggleSortOrder.bind(this);
    this.state = {
      sortOrder: 1,
      sortedHeaderIndex: null
    };
  }

  _toggleSortOrder(toggledHeaderIndex) {
    const headerIndex = parseInt(toggledHeaderIndex, 10);
    if (this.state.sortOrder === -1 || this.state.sortedHeaderIndex !== headerIndex) {
      this.setState({
        sortOrder: 1,
        sortedHeaderIndex: headerIndex
      });
    } else {
      this.setState({
        sortOrder: -1,
        sortedHeaderIndex: headerIndex
      });
    }
  }

  _getCSS() {
    return {
      '& tbody tr:hover td': {
        background: this._theme(1)
      }
    };
  }

  render() {
    const children = React.Children.map(this.props.children, child => {
      if (child.type.displayName === 'VstTableHeader') {
        return React.cloneElement(child, { onClick: this._toggleSortOrder });
      } else if (child.type.displayName === 'VstTableBody') {
        return React.cloneElement(child, {
          sortOrder: this.state.sortOrder,
          sortIndex: this.state.sortedHeaderIndex
        });
      }
      return child;
    });

    const rule = css(this._getCSS());

    return (
      <div className="vst-table-wrapper" style={{ height: this.props.height }}>
        <div className="vst-table-inner-wrapper">
          <table className={`vst-table ${rule}`} {...copyProps(this.props, ['items'])}>
            {children}
          </table>
        </div>
      </div>
    );
  }
}

VstTable.Header = VstTableHeader;
VstTable.Header.displayName = 'VstTableHeader';
VstTable.Body = VstTableBody;
VstTable.Body.displayName = 'VstTableBody';
VstTable.Row = VstTableRow;
VstTable.Cell = VstTableCell;

export default VstTable;
